/*
 * Module for Engines
 */

define([
  "marionette",
  "messaging/messenger",
  "backbone",
  "modules/accountAdmin/engineAdmin/engineAdminView",
  "modules/shared/sortableList/sortableListModule",
  "modules/accountAdmin/engineAdminModal/engineAdminModalModule",
  "modules/accountAdmin/engineAdmin/engineAdminModel",
  "./engineKbModal/engineKbModalModule",
], function (
  Marionette,
  Messenger,
  Backbone,
  EngineAdminView,
  SortableListModule,
  EngineAdminModalModule,
  EngineAdminModel,
  EngineKbModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "engineAdmin";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (options) {
      const globalAdmin = Messenger.reqres.request("user:is:global:admin");
      if (!globalAdmin) {
        // Only allow the Global Admin to use this module
        Backbone.history.navigate("#", { trigger: true });
      }
      this.engines = Messenger.reqres.request("engines");
      this.engineKbs = Messenger.reqres.request("engineKbs");
      this.kbs = Messenger.reqres.request("admin:kbs");

      Messenger.onSave(() => {
        Messenger.saveAttempted(true);
      });

      this.layout = new EngineAdminView.engineAdminLayout();
      const engineHeaders = Messenger.reqres.request("engine:admin:headers");
      const engineKbHeaders = Messenger.reqres.request("engineKb:admin:headers");

      const extendedEvents = {
        "click .deleteEngine": function () {
          const model = this.model;
          if (model.get("kbCapacity")["usage"] === 0) {
            Messenger.yesNoDialog(
              "admin.engineAdmin.confirmDeleteEngine",
              {
                yes: function () {
                  Messenger.vent.trigger("track:interaction", {
                    action: "Delete Engine",
                    id: model.id,
                    idType: "Engine",
                    object: "Engine",
                  });
                  model.deleteModel();
                },
              },
              this,
            );
          }
        },
        "click .deleteEngineKb": function () {
          const model = this.model;
          Messenger.yesNoDialog(
            "admin.engineAdmin.confirmRemoveKb",
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Remove Knowledge Base from Engine",
                  id: model.id,
                  idType: "Engine KB",
                  object: "Engine KB",
                });
                model.deleteModel();
              },
            },
            this,
          );
        },
      };

      this.engineList = this.addSubModule(
        new SortableListModule({
          region: this.layout.engineList,
          headers: engineHeaders,
          hideControls: true,
          namespace: this.name + ":engines",
          extendedEvents: extendedEvents,
        }),
      );

      this.engineKbList = this.addSubModule(
        new SortableListModule({
          region: this.layout.engineKbList,
          headers: engineKbHeaders,
          hideControls: true,
          namespace: this.name + ":engineKbs",
          extendedEvents: extendedEvents,
        }),
      );

      //add a new engine to the list
      this.layout.on("add:engine", this._addEngine, this);
      this.layout.on("add:engineKb", this._addEngineKb, this);

      this.layout.on(
        "show",
        function () {
          this.engineList.show(this.engines);
          this.engineKbList.show(this.engineKbs);
          let engineId = options ? options.engineId : null;
          if (engineId == "new") {
            this._addEngine();
          } else if (engineId) {
            engineId = +engineId;
            if (engineId && !isNaN(engineId)) {
              const engine = this.engines.get(engineId);
              if (engine) {
                this._showEngineModal(engine);
              }
            }
          }
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _addEngine: function () {
      const newItem = this.engines.addItem();
      //show the engine admin modal
      Messenger.vent.trigger(
        "show:modal",
        EngineAdminModalModule,
        {
          editMode: false,
        },
        newItem,
        {
          title: "admin.engineAdmin.addEngine",
          closeButton: false,
          closeOnBackgroundClick: false,
          modalWidth: 550,
          trackInteraction: {
            action: "Add Engine",
            object: "Engine",
          },
        },
      );
    },
    _addEngineKb: function () {
      //show the engine KB modal
      Messenger.vent.trigger(
        "show:modal",
        EngineKbModalModule,
        {},
        {
          engines: this.engines,
          engineKbs: this.engineKbs,
          kbs: this.kbs,
        },
        {
          title: "admin.engineAdmin.addEngineKb",
          closeButton: false,
          closeOnBackgroundClick: false,
          modalWidth: 550,
          trackInteraction: {
            action: "Add KB to Engine",
            object: "Engine KB",
          },
        },
      );
    },
    _setUpVents: function () {
      //Show the engine admin screen
      Messenger.vent.on(
        "show:account:admin:engines",
        function (engineId) {
          Backbone.history.navigate("accountAdmin/engines");
          this.show({ engineId: engineId });
        },
        this,
      );

      Messenger.vent.on(this.name + ":engines:selected:row", this._showEngineModal, this);
    },
    _showEngineModal: function (model) {
      Messenger.vent.trigger(
        "show:modal",
        EngineAdminModalModule,
        {
          editMode: true,
        },
        model,
        {
          title: "admin.engineAdmin.editEngine",
          closeButton: false,
          closeOnBackgroundClick: false,
          modalWidth: 550,
          trackInteraction: {
            action: "Edit Engine",
            id: model.id,
            idType: "Engine",
            object: "Engine",
          },
        },
      );
    },
  });
});
